<div class="container mt" id="service-container">
  <div class="service-content select-service">
    <div id="service-request-container" class="container-fluid">
      <div *ngIf="allChecklistLoading$ | async" id="loading-spinner">
        <app-loading size="0.5" color="var(--primary-sec-color)"></app-loading>
      </div>
      <div *ngIf="!(allChecklistLoading$ | async) && step?.controls">
        <div class="title-container">
          <span class="step-title">{{'service.chooseFromChecklist' | translate}}</span>
        </div>
        <div class="descr">{{getChecklistDescrMsg()}}</div>
        <div class="warning-msg">
          <div><span class="material-icons">info</span></div>
          <div>{{'deliveryChecklist.pleaseSelectAllRequired' | translate}} (<span style="color: red;">*</span>)
            {{'deliveryChecklist.itemsFromTheChecklist' | translate}}</div>
        </div>
        <div class="verificationContainer">
          <div class="verificationInput">
            <div style="display: flex;">
              <span class="service-name mandatory-tag" style="margin-left: 0.5rem;height:1.5rem;">{{'checklist.required' | translate}}</span>
              <p style="margin-left: 0.5rem;">{{'deliveryChecklist.vinVerification' | translate}}<span style="color: red;">*</span></p>
            </div>
            <div class="verify">
              <mat-form-field class="mat-input" appearance="outline">
                <input type="text" matInput autocomplete="off" maxlength="6" (input)="validateVIN($event)"
                  (paste)="$event.preventDefault()">
              </mat-form-field>
              <div style="display: flex;align-items: center;margin-left: 1rem;">
                <span>{{'deliveryChecklist.enterlast6digits' | translate}}</span>
              </div>
              <div style="margin-left: 0.5rem;margin-top:0.9rem;">
                <div class="status-icon" [ngClass] = "'success'" >
                  <asp-icon name="ic-20-alert-tick.svg" path="svg/" height = "25px" width = "25px" *ngIf="isVINCorrect"></asp-icon>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="enteredVin.length===6 && !isVINCorrect" class="vinError">
            <p>
              {{'deliveryChecklist.vinDoesntMatch' | translate}}
            </p>
          </div>
        </div>
        <div [ngClass]="!isVINCorrect ? 'disable-component': ''">
          <div class="row">
            <div class="col-md-12 mb-2">
              <form [formGroup]="step">
                <div *ngFor="let item of allOnlineCategories">
                  <div class="d-flex mt-3 mb-3 w-100">
                    <span class="step-subtitle">{{item}}</span>
                    <div class="service-counter ml-3">{{selectedCategoryTracker[item].selected}}</div>
                  </div>
                  <div [formArrayName]="item" *ngFor="let checklist of getControls(item), let i =index">
                    <mat-expansion-panel class="your-info-expansion" [expanded]="checklist.value.isExpanded"
                      (opened)="checklist.get('isExpanded').patchValue(true)"
                      [class.hide-body]='checklist.value.description && !(checklist.value.childChecklist.length > 0)'
                      [disabled]="!(checklist.value.description || checklist.value.childChecklist.length > 0)"
                      (closed)="checklist.get('isExpanded').patchValue(false)" [formGroupName]="i">
                      <mat-expansion-panel-header>
                        <mat-panel-title class="d-block step-title">
                          <div class="d-flex expansion-body">
                            <div class="service-title-panel my-4 w-100">
                              <mat-checkbox [checked]="checklist.value?.isChecked" [name]="checklist.value?.displayName"
                                class="service-checkbox d-flex mt-1 pt-2" disableRipple
                                (change)="onParentCheckboxChange($event,item, i)" (click)="$event.stopPropagation()"
                                (keydown)="handleKeyEvent($event)"
                                (keydown.Space)="onParentCheckboxChange($event,item, i)"
                                [id]='checklist.value.checklistId'>
                              </mat-checkbox>
                              <span class="service-name"><span *ngIf="checklist.value.isMandatory" class="service-name mandatory-tag">{{'checklist.required' | translate}}</span>&nbsp;{{checklist.value?.displayName}}<span
                                  *ngIf="checklist.value.isMandatory" style="color: red">*</span></span>

                            </div>
                          </div>
                          <div class="service-name">
                            <p [ngClass]="checklist.value.isExpanded ? 'description-expanded' : 'description'">
                              {{checklist.value.description}}</p>
                          </div>
                        </mat-panel-title>

                      </mat-expansion-panel-header>
                      <div class="expansion-body">
                        <div
                          *ngIf="checklist.value?.isChildChecklistEnabled && checklist.value?.childChecklist?.length > 0"
                          class="includes-text">Includes</div>
                        <div
                          *ngIf="checklist.value?.isChildChecklistEnabled && checklist.value?.childChecklist?.length > 0">
                          <div class="step-title child-checkbox"
                            *ngFor="let child of checklist.value.childChecklist, let childIndex = index">
                            <ng-template [ngIf]="child?.online">
                              <mat-checkbox [checked]="child?.isChecked" [name]="child?.name" class="service-checkbox"
                                disableRipple
                                (change)="onChildCheckboxChange($event,item,checklist.value.checklistId,child.id, i, childIndex)"
                                [id]="child?.id"
                                (keydown)="handleKeyEvent($event)"
                                (keydown.Space)="onChildCheckboxChange($event,item,checklist.value.checklistId,child.id, i, childIndex)">
                              </mat-checkbox>
                              <span class="service-name">{{child?.name}}<span *ngIf="child.isMandatory"
                                  style="color: red">*</span></span><span
                                class="child-duration-span ml-4 ml-md-auto">{{child?.displayTime}}</span>
                            </ng-template>
                          </div>
                        </div>
                      </div>
                    </mat-expansion-panel>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>